import { apiRequest } from './client';

export interface SettingItem {
  key: string;
  group: string;
  label: string;
  type: string;
  value: string;
  public: boolean;
}

export type PublicSettings = Record<string, string>;

export const fetchPublicSettings = (): Promise<PublicSettings> => apiRequest<PublicSettings>('/public/settings');
export const fetchSettings = async (): Promise<SettingItem[]> => (await apiRequest<{ items: SettingItem[] }>('/settings')).items;
export const updateSettings = async (values: Record<string, string>): Promise<SettingItem[]> => (await apiRequest<{ items: SettingItem[] }>('/settings', { method: 'PATCH', body: { values } })).items;
